import { QueryFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from '../api';

type Config = {
  ENV: string;
  CHAT_PATH: string;
  DEV_ASSISTANT_SECRET: string;
};

export const getConfig = (): Config => ({
  ENV: process.env.NODE_ENV,
  // When developing locally, we use a slightly different url for the chat.
  // NOTE: If we don't do this, the chat will load, but it will be from production
  // and and local changes will not appear, potentially driving you crazy.
  CHAT_PATH: process.env.NODE_ENV === 'development' ? '' : '/echat/index.html',
  // For local development only — read at call time so tests/env changes apply.
  DEV_ASSISTANT_SECRET: process.env.DEV_ASSISTANT_SECRET,
});

// Define a default query function that will receive the query key
const defaultQueryFn: QueryFunction = async ({ queryKey }): Promise<AxiosResponse['data']> => {
  return API().get({ path: queryKey[0] as string });
};

export const clientConfig = {
  defaultOptions: {
    queries: {
      gcTime: 0,
      queryFn: defaultQueryFn,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
};
